export class InvalidResponseError extends Error {
  static name = 'InvalidResponseError'
  name = 'InvalidResponseError'
}
